module.exports = __webpack_public_path__ + "static/media/ring-line-3.3c82f56e.svg";